import { useEffect } from 'react';

const useScrollHandler = (handler: Function): void => {
  useEffect(() => {
    const mainElement = document.querySelector('main')?.children[0];
    if (mainElement) {
      mainElement.addEventListener('scroll', () => {
        handler();
      });
    }

    return () => {
      if (mainElement) {
        mainElement.removeEventListener('scroll', () => {
          handler();
        });
      }
    };
  }, [handler]);
};

export default useScrollHandler;
